import {useEffect, useState} from 'react'
import { setTitlePage, isValidDate, isOnlyNumbers } from '../../Functions'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Link } from 'react-router-dom'
import { getAccountDetail } from "../../Api";
import { useAuth } from '../../../app/modules/auth'
import PaginationComponent from '../../components/PaginationComponent/PaginationComponent';
import Axios from "axios";
import Search from './Search';
import Table from './Table';
import { AlertDialog } from '../../components/Dialog/Dialog';
import GlobalLoading from '../../components/GlobalLoading';

const AccountDetail = () => {
  const { auth } = useAuth();
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState('No se encontraron resultados para tu búsqueda.');
  const [state, setState] = useState({
    data: [],
    pageCount: 0,
    pageIndex: 0,
    pageSize: 0,
    pages: 0,
    loading: false,
  });
  const [filters, setFilters] = useState({
    rolclinica: '',
    paciente: '',
    rolprof: '0',
    codigo_prestacion: '',
    start_date: '',
    finish_date: '',
    estado: '0',
    nombrepaciente: '',
  });

  useEffect(() => {
    setTitlePage('Detalle Cuentas');
  }, [])

  const setData = (name: string, value: any) => {
    setFilters({...filters, [name]: value});
  }

  const onChange = (e:any) => {
    const { name, value } = e.target;
    setData(name, value);
    // setFilters({...filters, [name]: value});
  }

  const loadData = async (pageIndex = 0, pageCount = 10) => {
    const data = {...filters, paginate: pageIndex, numberrecords : pageCount}
    const startDate = data.start_date.length > 0 ?  data.start_date + '-01' : '';
    const endDate = data.finish_date.length > 0 ?  data.finish_date + '-01' : '';
    if(startDate.length > 0 && !isValidDate(startDate)) {
      setMessageAlertError('El formato de Fecha Desde, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(endDate.length > 0 && !isValidDate(endDate)) {
      setMessageAlertError('El formato de Fecha hasta, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(data.rolclinica.length > 0 && (!isOnlyNumbers(data.rolclinica) || data.rolclinica.length > 15)){
      setMessageAlertError('El formato del ID Clínica, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(data.codigo_prestacion.length > 0 && (!isOnlyNumbers(data.codigo_prestacion) || data.codigo_prestacion.length > 15)){
      setMessageAlertError('El formato de la Prestación, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(data.estado.length > 0 && (!isOnlyNumbers(data.estado) || data.estado.length > 15)){
      setMessageAlertError('El formato del Estado, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(data.paciente.length > 0 && (!isOnlyNumbers(data.paciente) || data.paciente.length > 15)){
      setMessageAlertError('El formato del Rut Paciente, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(data.nombrepaciente.length > 0 && data.nombrepaciente.length > 50){
      setMessageAlertError('El limite de caracteres en Nombre paciente es 50!');
      setShowAlertError(true);
      return;
    }
    setState({...state, loading: true});
    const _response:any = await getAccountDetail(data);
    if (_response?.status) {
      const { totalrecords, paginate, totalpaginate } = _response.data.pagination;
      setState({
        data: _response.data.records,
        pageCount: parseInt(totalrecords),
        pageIndex: parseInt(paginate),
        pageSize: pageCount,
        pages: parseInt(totalpaginate),
        loading: false,
      });
      if (totalrecords === 0) {
        setShowAlertError(true);
        setMessageAlertError('No se encontraron resultados para tu búsqueda.');
      }
    } else {
      setShowAlertError(true);
      setMessageAlertError('No se encontraron resultados para tu búsqueda.');
      setState({
        data: [],
        pageCount: 0,
        pageIndex: 0,
        pageSize: 0,
        pages: 0,
        loading: false,
      });
    }
  }

  const downloadExcel = async () => {

    const params = new URLSearchParams(filters).toString();
    const url = process.env.REACT_APP_API_URL;

    setLoadingExcel(true);
    Axios({
      url: `${url}/auth/detallecuentapam/search?excel=1&${params}`,
      method: "GET",
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${auth?.access_token}`
      },
    }).then((response) => {
      if(response.data.status){
        const link = document.createElement("a");
        link.href = response.data.file;
        link.setAttribute('download', `${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert('No se generó el archivo');
      }
    }).finally(() => {
      setLoadingExcel(false);
    });
  } 

  return (
    <>
      <GlobalLoading show={loadingExcel} message='GENERANDO EXCEL'/>
      <div className="row mb-2">
        <div className="card col-md-3 offset-md-9">
          <Link to="/grafico/evolutivo" className="btn btn-white me-2 fs-3 fw-bold">
            Gráfico Evolutivo  <img src={toAbsoluteUrl('/media/icons/4146963.png')} style={{ marginLeft: '10px', maxWidth: '50px' }} alt="..." />
          </Link>
        </div>
      </div>

      <Search filters={filters} setData={setData} onChange={onChange} loadData={loadData} downloadExcel={downloadExcel}  />
    
      <Table state={state}/>

      <PaginationComponent totalPages={state.pages} activePage={state.pageIndex} searchData={loadData} loading={state.loading} />

      <AlertDialog
        message={messageAlertError}
        show={showAlertError}
        success={false}
        onConfirm={() => {
            setShowAlertError(false);
        }}
      />
    </>
  )
}

export default AccountDetail;